import { getBookingAsyncResponse } from "./types";
import * as bookingActions from "./actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiGet, API_URL_BOOKING, retrieveToken } from "../../../helpers/api";

export function* getBookings(action: ReturnType<typeof bookingActions.getBookingAsync.request>) {
  try {
    const page = action.payload.page ? action.payload.page : 1;
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiGet, API_URL_BOOKING.GET_BOOKINGS(page), token);
    if (result.status === 200) {
      const parsed: getBookingAsyncResponse = yield call(result.json.bind(result));
      yield put(bookingActions.getBookingAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(bookingActions.getBookingAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(bookingActions.getBookingAsync.failure(parsed));
  }
}

export default function* bookingsSagaGetBooking() {
  yield takeEvery(bookingActions.getBookingAsync.request, getBookings);
}
